const Mutations = Object.freeze({
	SET_SETTINGS: 'projectSettings/generalSettings/SET_SETTINGS',
});

export const Actions = Object.freeze({
	LOAD_SETTINGS: 'projectSettings/generalSettings/LOAD_SETTINGS',
	SAVE_SETTINGS: 'projectSettings/generalSettings/SAVE_SETTINGS',
});

export const Getters = Object.freeze({
	SETTINGS: 'projectSettings/generalSettings/SETTINGS',
	PK_EXEPTION_LIST: 'projectSettings/generalSettings/PK_EXEPTION_LIST',
	USER_DISPLAY_FORMAT: 'projectSettings/generalSettings/USER_DISPLAY_FORMAT',
});
import dataService from '../../../../../services/data/projectSettingsService';
import { GeneralSettings } from '../../../../../enums/GeneralSettings';
import { GeneralActions, ProjectContextActions } from '../../../../actions';
export default {
	state: {
		settings: [],
	},

	mutations: {
		[Mutations.SET_SETTINGS](state, value) {
			let exeptionIndex = value.indexOf(
				value.find(
					(x) => x.Name == GeneralSettings.PRIMARY_KEY_EXEPTION_LIST
				)
			);
			if (exeptionIndex >= 0 && value[exeptionIndex].Value)
				value[exeptionIndex].Value = JSON.parse(
					value[exeptionIndex].Value
				);
			state.settings = value;
		},
	},
	actions: {
		[Actions.LOAD_SETTINGS]({ commit, dispatch }) {
			dispatch(GeneralActions.LOADING, true);
			return new Promise((resolve) => {
				dataService
					.getSettings()
					.then((resp) => {
						commit(Mutations.SET_SETTINGS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.SAVE_SETTINGS]({ commit, dispatch }, items) {
			dispatch(GeneralActions.LOADING, true);
			let index = items.indexOf(
				items.find(
					(x) => x.Name == GeneralSettings.PRIMARY_KEY_EXEPTION_LIST
				)
			);
			if (index >= 0 && items[index].Value)
				items[index].Value = JSON.stringify(items[index].Value);
			return new Promise((resolve) => {
				dataService
					.updateSettings(items)
					.then(() => {
						commit(Mutations.SET_SETTINGS, items);
						return dispatch(
							ProjectContextActions.LOAD_PROJECT_SETTINGS
						);
					})
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.SETTINGS]: (state) => {
			if (state.settings.length > 0) {
				return JSON.parse(JSON.stringify(state.settings));
			}
			return [];
		},
		[Getters.PK_EXEPTION_LIST]: (state) => {
			if (state.settings.length > 0) {
				return JSON.parse(
					JSON.stringify(
						state.settings.find(
							(x) =>
								x.Name ==
								GeneralSettings.PRIMARY_KEY_EXEPTION_LIST
						).Value
					)
				);
			}
		},
		[Getters.USER_DISPLAY_FORMAT]: (state) => {
			if (state.settings.length > 0) {
				return JSON.parse(
					JSON.stringify(
						state.settings.find(
							(x) => x.Name == GeneralSettings.USER_DISPLAY_FORMAT
						).Value
					)
				);
			}
		},
	},
};
